define('SageDotCom/Components/DynamicProductCard/DynamicPriceSelector',["jquery", "eventManager", "SageDotCom/Components/ProductCardAlignment", "SageDotCom/Utility/sanitizer"],
    function ($, eventManager, productCardAlignment, sanitizer) {
        function DynamicPriceSelector(scope, productSku, promoSku, prePriceText, postPriceText, fallbackPromoTemplate, useContactUs, priceWithTax, isEditing) {
            let selectElement = $("select", scope);
            let parentCard = $(scope).parents(".sage-product-card-outer");
            let productCardButtons = parentCard.find(".score-button.product-card-cta-alt");
            let productPricingArea = parentCard.find(".sage-product-card-price-options-area");
            let priceElement = parentCard.find(".price.promo-price-before");
            let promoWrapper = parentCard.find(".sage-product-card-promotion-banner-wrapper-alt");
            let locale = undefined;

            let product = "";
            let variants = [];
            let promotion = "";

            if (isEditing || $("body").hasClass("mode-experience-editor")) {
                const currentUrl = new URL(window.location.href);
                locale = currentUrl.searchParams.get('sc_lang');
            }

            if (typeof (locale) === "undefined") {
                const localeArr = document.location.pathname.split("/");
                for (let i = 0; i < localeArr.length; i++) {
                    if (localeArr[i] !== "") {
                        locale = localeArr[i];
                        break;
                    }
                }
            }

            //show contact us screen until commerce info is loaded in
            contactUsFunctionality();

            promoWrapper.find(".spacer").remove();
            productPricingArea.css("margin-bottom", "40px");

            // fallback for match height if still waiting for Commerce API info
            var matchHeightTimeout = setTimeout(productCardAlignment.sageProductCardMatchHeight(), 500);

            // set up on change event to update price box, promotion text and button URLs
            $(selectElement).on("change", function () {
                clearTimeout(matchHeightTimeout);

                prePriceText !== null && prePriceText !== "" ? parentCard.find(".sage-product-card-price-options-area .sage-product-card-price-box .price-pre-text").text(prePriceText) : "";
                postPriceText !== null && postPriceText !== "" ? parentCard.find(".sage-product-card-price-options-area .main-price-line .price-post-text").text(postPriceText) : "";
                productCardButtons = parentCard.find(".score-button.product-card-cta-alt");

                var selectedValue = $(this).val();
                
                if (selectedValue === "ContactUs") {
                    contactUsFunctionality();
                }
                else {
                    var selectedVariant;
                    var variantId = selectedValue.replace("vid", "");

                    variants.forEach((variant) => {
                        if (variant.Id === variantId) {
                            selectedVariant = variant;
                        }
                    });

                    if (selectedVariant != null) {
                        // show promotion price with/without tax if promotion is active and promotion price is not 0
                        // otherwise show priceIncModules with/without tax
                        var variantPrice = priceWithTax ? selectedVariant.Totals.FormattedPriceIncModulesWithTax : selectedVariant.Totals.FormattedPriceIncModules;
                        var variantPromoPrice = priceWithTax ? selectedVariant.Totals.FormattedDiscountedPriceWithTax : selectedVariant.Totals.FormattedDiscountedPrice;
                        var variantSavingPrice = priceWithTax ? selectedVariant.Totals.FormattedTotalDiscountOverPeriodWithTax : selectedVariant.Totals.FormattedTotalDiscountOverPeriod;

                        if (promotion !== null && promotion !== undefined && promotion.PromoTemplate !== null && promotion.PromoTemplate !== "") {

                            var unformattedPromoPrice = priceWithTax ? selectedVariant.Totals.DiscountedPriceWithTax : selectedVariant.Totals.DiscountedPrice;
                            if (Math.abs(unformattedPromoPrice) === 0) {
                                // must be deal of 100% off so show normal price
                                priceElement.html(variantPrice);
                            }
                            else {
                                priceElement.html(variantPromoPrice);
                            }

                            //update promo details
                            var newPromoHtml = promotion.PromoTemplate.replace("{cartText}", promotion.CartText).replace("{listPrice}", variantPrice).replace("{yousave}", variantSavingPrice);
                            newPromoHtml = sanitizer.sanitizeHtml(newPromoHtml);
                            parentCard.find(".sage-product-card-promotion-banner-alt").html(newPromoHtml);
                            promoWrapper.show();
                        }
                        else {
                            priceElement.html(variantPrice);
                            promoWrapper.hide();
                        }
                    }

                    productCardButtons.each(function () {
                        var currentButton = $(this);
                        if (currentButton.hasClass("contact-us")) {
                            currentButton.hide();
                        }
                        else {
                            // update button URLS with the vid selected
                            var currentButtonHref = currentButton.attr("href");
                            var url = new URL(currentButtonHref);

                            if(!$(this).hasClass("try-button")) {
                                if (promotion !== null && promotion !== undefined) {
                                    url.searchParams.set("promocode", promotion.Code);
                                }
                                else {
                                    url.searchParams.delete("promocode");
                                }
                            }
                            url.searchParams.set("vid", variantId);

                            currentButton.attr("href", url.href);
                            currentButton.show();
                        }
                    });
                    parentCard.find(".main-price-line").show();

                }
                productCardAlignment.sageProductCardMatchHeight();
            });

            $.ajax({
                type: "GET",
                url: `/sitecore/api/product/GetDynamicPriceSelectorData/${productSku}/${locale}`,
                data: {
                    promoCode: promoSku
                },
                context: this,
                success: function (response) {
                    if (response != null) {
                        clearTimeout(matchHeightTimeout);

                        const jsonObj = response;
                        if (jsonObj.Promotion !== "" && jsonObj.Promotion !== null && jsonObj.Promotion !== undefined) {
                            // add template fallback
                            if (jsonObj.Promotion.PromoTemplate === null || jsonObj.Promotion.PromoTemplate === "") {
                                jsonObj.Promotion.PromoTemplate = fallbackPromoTemplate;
                            }
                        }
                        promotion = jsonObj.Promotion;

                        product = jsonObj.Product;

                        variants = jsonObj.Product.Variants;
                        var selectorOptionNames = [];
                        var selectorOptionValues = [];

                        variants.forEach((variant) => {
                            selectorOptionNames.push(variant.DisplayName);
                            selectorOptionValues.push("vid" + variant.Id);
                        });

                        if (useContactUs) {
                            var lastVariant = variants[selectorOptionNames.length - 1];
                            var lastVariantEmployees = lastVariant.MaxEmployees;
                            var employeeNumber = lastVariantEmployees + "+ Employees";
                            selectorOptionNames.push(employeeNumber);
                            selectorOptionValues.push("ContactUs");
                            // only show the contact us button as the buy and try buttons will not have correct url due to no variants

                        }

                        $(selectElement).empty();
                        for (i = 0; i < selectorOptionValues.length; i++) {
                            $(selectElement).append(new Option(selectorOptionNames[i], selectorOptionValues[i]));
                        }

                        // trigger on change
                        $(selectElement).trigger("change");
                        productCardAlignment.sageProductCardMatchHeight();
                    }
                },
                error: function (xhr) {
                    $(scope).hide(); // hide the component on error
                    contactUsFunctionality();
                }
            });

            function contactUsFunctionality() {
                productCardButtons = parentCard.find(".score-button.product-card-cta-alt");
                var contactUsText = "";
                productCardButtons.each(function () {
                    var currentButton = $(this);
                    currentButton.hasClass("contact-us") ? currentButton.show() : currentButton.hide();
                    contactUsText = currentButton.hasClass("contact-us") ? currentButton.text() : "Contact Us";
                });
                priceElement.text(contactUsText);
                promoWrapper.hide();
                parentCard.find(".main-price-line").hide();
            }
        }

        DynamicPriceSelector.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new DynamicPriceSelector(args.scope, args.productSku, args.promoSku, args.prePriceText, args.postPriceText, args.fallbackPromoTemplate, args.useContactUs, args.priceWithTax, args.isEditing);
        };

        return DynamicPriceSelector;
    });
